"use client";
import styled from "styled-components";
import { Accordion, Col, Tab, Tabs } from "react-bootstrap";
import { BsChevronDown } from "react-icons/bs";
import React, {useEffect, useState} from "react";
import { Black, hover } from "@/styles/globalStyleVars";
import Select, { components } from "react-select";
import ThemeContainer from "@/components/theme/container";
import reactHtmlParser from "react-html-parser";
import Link from "next/link";
import { gsap } from "gsap";

const Address = ({ data, filter }) => {
  const iframeStyle = {
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    border: 0,
  };
  const customStyles = {
    dropdownIndicator: (base, state) => ({
      ...base,
      transition: "all .2s ease",
      // transform: state.selectProps.menuIsOpen && "rotate(180deg)"
    }),
    option: (provided, state) => ({
      ...provided,
      borderRadius: 0,
      color: state.isSelected ? `${hover}` : "#221F1F",
      backgroundColor: state.isSelected ? `rgba(232, 231, 231, 0.6)` : "#FFF",
      margin: 0,
      fontSize: 14,
      cursor: "pointer",
      paddingLeft: 10,
      paddingRight: 10,
      fontWeight: state.isSelected ? 600 : 400,
      "&:hover": {
        backgroundColor: `rgba(232, 231, 231, 0.8)`,
        color: "#FFF",
        cursor: "pointer",
      },
    }),
    menu: (provided, state) => ({
      ...provided,
      color: "#FFF",
      backgroundColor: state.isSelected ? `${hover}` : "rgba(255,255,255,0)",
      margin: 0,
      borderRadius: 0,
      fontSize: 14,
      zIndex: 10,
      // width: 200,
    }),
    menuList: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? `${hover}` : "#FFF",
      borderRadius: 0,
      fontWeight: "400",
      color: "#FFF",
      // fontSize: 14,
    }),
  };

  const CaretDownIcon = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="13.414"
        height="7.414"
        viewBox="0 0 13.414 7.414"
      >
        <g
          id="Group_15659"
          data-name="Group 15659"
          transform="translate(1479.207 -192.793) rotate(90)"
        >
          <line
            id="Line_3883"
            data-name="Line 3883"
            x2="6"
            y2="6"
            transform="translate(193.5 1466.5)"
            fill="none"
            stroke="#FFFFFF"
            strokeLinecap="round"
            strokeWidth="1"
          />
          <line
            id="Line_3884"
            data-name="Line 3884"
            y1="6"
            x2="6"
            transform="translate(193.5 1472.5)"
            fill="none"
            stroke="#FFFFFF"
            strokeLinecap="round"
            strokeWidth="1"
          />
        </g>
      </svg>
    );
  };
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <CaretDownIcon />
      </components.DropdownIndicator>
    );
  };

  const [activeKey, setActiveKey] = useState("tab_0");
  const handleSelect = (selectedOption) => {
    const value = selectedOption ? selectedOption.value : "media";
    setActiveKey(value);
  };
  const options = filter.map((item, index) => ({
    value: "tab_" + index,
    label: item.name,
  }));
  
  const [isDesktop, setIsDesktop] = useState(false);
  
  useEffect(() => {
    setIsDesktop(window.innerWidth > 767);
    
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 767);
    };
    
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <StyledAddress className="address pt-150 pb-150">
      {isDesktop ? (
        ""
      ) : (
        <ThemeContainer containerClass={"p-0"} fluid>
          <div className="address-filter__mobile">
            <Select
              classNamePrefix="filter"
              onChange={(e) => handleSelect(e)}
              isSearchable={false}
              styles={customStyles}
              components={{ DropdownIndicator }}
              options={options}
              placeholder={"All"}
              value={options.find((option) => option.value === activeKey)} // Ensure Select displays the correct value
            />
          </div>
        </ThemeContainer>
      )}

      <ThemeContainer colProps={{ md: 12 }}>
        <Tabs
          activeKey={activeKey}
          onSelect={(k) => {
            setActiveKey(k);
          }}
          id="uncontrolled-tab-example"
          className="mb-3 address-cat-list"
        >
          {filter &&
            filter?.length > 0 &&
            filter?.map((e, index) => {
              return (
                <Tab eventKey={"tab_" + index} title={e?.name}>
                  <Accordion defaultActiveKey="accordion_0">
                    {data &&
                      data?.length > 0 &&
                      data?.map((item, key) => {
                        if (e?.slug === item?.address_type?.slug) {
                          return (
                            <Accordion.Item
                              key={key}
                              eventKey={"accordion_" + key}
                            >
                              <Accordion.Header>
                                <div className="contact-numbers d-flex">
                                  <Col className="pl-0" sm={2}>
                                    {item?.post_title && (
                                      <h4>{item?.post_title}</h4>
                                    )}
                                  </Col>

                                  <Col className="pl-0" sm={3}>
                                    {item?.branch_Address && (
                                      <>
                                        <p>Address</p>
                                        <ul>
                                          <li>
                                            <Link
                                              href={item?.map_link}
                                              target={"_blank"}
                                            >
                                              {reactHtmlParser(
                                                item?.branch_Address
                                              )}
                                            </Link>
                                          </li>
                                        </ul>
                                      </>
                                    )}
                                  </Col>
                                  <Col className="pl-0" sm={3}>
                                    {item?.office_in_charge && (
                                      <>
                                        <p>Office In charge</p>
                                        <ul>
                                          <li>
                                            <a>
                                              {reactHtmlParser(
                                                item?.office_in_charge
                                              )}
                                            </a>
                                          </li>
                                        </ul>
                                      </>
                                    )}
                                  </Col>

                                  <Col className="pl-0" sm={2}>
                                    {item?.contact_number && (
                                      <>
                                        <p>Phone</p>
                                        <ul>
                                          <li>
                                            <Link
                                              href={`tel:${item?.contact_number}`}
                                            >
                                              {item?.contact_number}
                                            </Link>
                                          </li>
                                        </ul>
                                      </>
                                    )}
                                  </Col>
                                  <Col className={"pl-0 map-btn"} sm={2}>
                                    <span>
                                      <BsChevronDown />
                                    </span>
                                    <p>Map</p>
                                  </Col>
                                </div>
                              </Accordion.Header>
                              <Accordion.Body>
                                <div className="map">
                                  {item?.embeded_map && (
                                    <div className={"map-body"}>
                                      <iframe
                                        style={iframeStyle}
                                        src={item?.embeded_map}
                                        allowFullScreen
                                      ></iframe>
                                    </div>
                                  )}
                                </div>
                              </Accordion.Body>
                            </Accordion.Item>
                          );
                        }
                      })}
                  </Accordion>
                </Tab>
              );
            })}
        </Tabs>
      </ThemeContainer>
    </StyledAddress>
  );
};
const StyledAddress = styled.section`
  background: #ffffff;

  .address-cat-list {
    display: flex;
    margin-bottom: 60px !important;
    border-bottom: 1px solid #191919 !important;

    li {
      border-left: 1px solid #191919 !important;
      position: relative;

      button {
        padding: 15px 30px;
        font-size: 16px;
        line-height: 24px;
        font-weight: 400;
        color: #191919;
        border-top-left-radius: unset;
        border-top-right-radius: unset;
        border: none !important;
        position: relative;
        z-index: 3;
        transition: color 0.3s ease;
        &.active {
          background-color: #191919 !important;
          color: #fff !important;
        }
        &:hover {
          color: #fff !important;
        }
      }
      &:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        background-color: #191919;
        height: 0;
        transition: 0.5s ease;
      }
      &:hover {
        &:after {
          height: 100%;
        }
      }
    }
  }

  .accordion-item {
    margin-bottom: 30px;
    padding-bottom: 30px;
    border-bottom: 1px solid rgba(25, 25, 25, 0.2) !important;
    &:nth-last-child(1) {
      margin-bottom: 0;
      border-bottom: 0 !important;
    }
  }

  .accordion-header {
    position: relative;
    margin: 0;

    button {
      border: none;
      background-color: transparent;
      padding-left: 0;
      //color: #180E81;
      font-size: 24px;
      font-weight: 300;
      line-height: 32px;
      text-transform: capitalize;
      //padding-bottom: 30px;
      //border-bottom: 1px solid #180E81;
      width: 100%;
      text-align: left;
      //margin-bottom: 50px;
      transition: all 0.4s ease;

      .contact-numbers {
        h4 {
          font-size: 24px;
          line-height: 32px;
          font-weight: 400;
          color: #191919;
          font-family: "Aeonik", Euclid Square, Arial, Helvetica, freesans,
            sans-serif;
        }
        p {
          font-size: 12px;
          line-height: 20px;
          color: rgba(25, 25, 25, 0.5);
          font-family: "Aeonik", Euclid Square, Arial, Helvetica, freesans,
            sans-serif;
        }
        ul {
          margin-top: 5px;
          li {
            a {
              font-size: 16px;
              line-height: 20px;
              color: #191919;
              pointer-events: none;
              font-family: "Aeonik", Euclid Square, Arial, Helvetica, freesans,
                sans-serif;
            }
            p {
              font-size: 16px;
              line-height: 20px;
              color: #191919;
              font-family: "Aeonik", Euclid Square, Arial, Helvetica, freesans,
                sans-serif;
            }
          }
        }
      }

      .map-btn {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 20px;
        p {
          color: ${hover};
        }
        @media (max-width: 767px) {
          justify-content: flex-start;
        }
      }

      &.collapsed {
        color: #1a1818;
        border-color: #1a1818;
        .map-btn {
          p {
            color: ${Black};
          }
        }
        span {
          background-color: black;

          svg {
            transform: rotate(0deg);
          }

          // &:after {
          //   background-color: ${hover} !important;
          // }
        }
      }
      @media (max-width: 767px) {
        .col-sm-2,
        .col-sm-3 {
          margin-bottom: 20px;
          br {
            display: none;
          }
        }
      }
    }

    span {
      //position: absolute;
      height: 30px;
      width: 30px;
      color: #ffffff;
      background-color: ${hover};
      right: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      bottom: 16px;

      // &:after {
      //   height: 0;
      //   width: 0;
      //   background-color: ${hover};
      //   opacity: 0;
      //   transition: all .4s ease;
      //   content: '';
      //   position: absolute;
      // }

      svg {
        font-size: 13px;
        z-index: 2;
        transform: rotate(180deg);
      }
    }

    &:hover {
      span {
        &:after {
          height: 100%;
          width: 100%;
          opacity: 1;
        }
      }

      button {
        color: ${hover};
        border-color: ${hover};
      }
    }
  }

  .accordion-body {
    padding-top: 30px;

    p {
      width: 70%;
    }

    p,
    a {
      font-size: 16px;
      line-height: 22px;
      font-weight: 600;
    }

    .contact-numbers {
      /* h4 {
        font-size: 14px;
        line-height: 20px;
        font-weight: 500;
        color: rgba(34, 31, 31, 0.2);
        margin: 0 0 10px 0;
        font-family: "Suisse Intl";
      } */

      ul {
        li {
          a {
            cursor: pointer;
            margin-bottom: 13px;
            display: flex;
            color: #262630;
            font-size: 16px;
            line-height: 24px;
            font-weight: 400;

            span {
              font-size: 26px;
              font-weight: bold;
              line-height: 32px;
              transition: 0.3s ease;
            }

            &:hover span {
              color: #180e81;
            }
          }

          &:nth-last-of-type(1) {
            margin-bottom: 0;
          }
        }
      }
    }

    .map {
      //margin-top: 45px;

      .map-body {
        position: relative;
        padding-top: calc(450 / 1170 * 100%);

        @media (max-width: 767px) {
          padding-top: calc(210 / 345 * 100%);
        }
      }

      iframe {
        width: 100%;
        height: 350px;
      }
    }
  }

  .address__form {
    .form-control {
      font-size: 16px;
      line-height: 22px;
      border: none;
      background-color: transparent;
      border-bottom: 1px solid black;
      border-radius: 0;
      padding-left: 0;
      padding-bottom: 20px;
      margin-bottom: 40px;

      &::placeholder {
        color: rgba(34, 31, 31, 0.5) !important;
        font-size: 16px;
        line-height: 22px;
        font-weight: 300;
      }
    }

    textarea {
      min-height: 90px;
      max-height: 90px;
      min-width: 100%;
      max-width: 100%;
      margin-bottom: 60px;
    }

    .divider {
      width: 100%;
      display: flex;
      justify-content: space-between;

      .form-control {
        width: calc(50% - 15px);
      }
    }

    &__title {
      margin-bottom: 60px;

      h5 {
        font-size: 16px;
        line-height: 22px;
        margin-bottom: 20px;
        font-weight: 600;
      }

      p {
        font-size: 26px;
        font-weight: bold;
        line-height: 32px;
      }
    }
  }

  @media (max-width: 768px) {
    .address__accordion {
      min-width: 100%;
    }

    .address__form {
      min-width: 100%;
      margin-top: 60px;
    }
  }

  @media (max-width: 767px) {
    padding-top: 40px;
    .address__row {
      flex-direction: column-reverse;
    }

    .address__form {
      margin-top: 0;
      margin-bottom: 60px;
    }

    .contact-numbers {
      flex-wrap: wrap;

      .col-sm-4 {
        min-width: 50%;

        &:nth-last-child(1) {
          margin-top: 30px;
          padding-left: 0;
        }
      }
    }
  }

  .address-cat-list {
    @media (max-width: 767px) {
      display: none;
    }
  }
  .address-filter__mobile {
    display: none;
    @media (max-width: 767px) {
      display: block;
      margin-bottom: 30px;
    }
  }

  .address-filter__mobile {
    .css-13cymwt-control {
      border-radius: 0px !important;
      border: 1px solid #191919 !important;
      min-height: 50px;
      &:hover {
        border: 1px solid #191919 !important;
      }
    }

    .css-1u9des2-indicatorSeparator {
      background-color: transparent;
    }

    .css-1dimb5e-singleValue {
      font-size: 17px;
      line-height: 24px;
      font-weight: 400;
      color: White !important;
      padding-top: 0;
    }

    .css-1jqq78o-placeholder {
      font-size: 24px;
      line-height: 32px;
      font-weight: 400;
      color: White !important;
      padding-top: 0;
      padding-left: 0 !important;
    }

    .css-yk16xz-control .css-1wa3eu0-placeholder,
    .css-1pahdxg-control .css-1wa3eu0-placeholder,
    .css-1uccc91-singleValue {
      color: #3c4348 !important;
      font-size: 16px !important;
      font-weight: bold;
      cursor: pointer;
      letter-spacing: 2px !important;
      text-transform: capitalize !important;
    }

    .filter__single-value.css-1dimb5e-singleValue {
      text-transform: capitalize;
      padding-left: 0px !important;
    }

    .css-1s4cg4l-indicatorContainer {
      font-size: 16px;
      line-height: 24px;
      font-weight: 500;
      color: White !important;
      margin-right: 5px !important;
    }

    .filter__control {
      border-radius: 0 !important;
      background-color: #191919 !important;

      &--menu-is-open {
        border-radius: 0 !important;
        background-color: #191919 !important;
      }
    }

    .filter__dropdown-indicator {
      margin-right: 5px !important;
    }
    .css-t3ipsp-control {
      box-shadow: none !important;
      border-color: unset !important;
      min-height: 50px;
    }

    .css-1fdsijx-ValueContainer {
      padding: 15px 15px;
    }
  }
`;

export default Address;
